import createConverter from './lib/create_converter';
import ChannelConfiguration from 'models/channel_configuration';

export default createConverter(ChannelConfiguration);
